import { QuizBoard } from "@/modes/quiz/QuizBoard";
import { QuizTeacher } from "@/modes/quiz/QuizTeacher";
import { QuizSettings } from "@/modes/quiz/QuizSettings";
import { SettingSelect } from "@/components/game/SettingFields";
import { BingoBoard, BingoStudent, BingoTeacher } from "@/modes/activity/BingoViews";
import { SortBoard, SortStudent, SortTeacher } from "@/modes/activity/SortViews";
import { WrittenStudent } from "@/modes/activity/WrittenViews";
import { BoardSortBoard, BoardSortStudent, BoardSortTeacher } from "@/modes/activity/BoardSortViews";

const ActivitySettings = ({ settings, onChange }) => <QuizSettings settings={settings} onChange={onChange} hideLive />;
const BingoSettings = ({ settings, onChange }) => (
  <>
    <SettingSelect label="Otomatik çekiliş aralığı" value={settings.auto_draw_interval ?? 15} testId="setting-auto-draw-interval"
      onChange={(v) => onChange({ auto_draw_interval: Number(v) })} options={[[10, "10 sn"], [15, "15 sn"], [20, "20 sn"], [30, "30 sn"]]} />
    <ActivitySettings settings={settings} onChange={onChange} />
  </>
);

export const bingo = { key: "bingo", label: "Tombala", SettingsForm: BingoSettings, StudentView: BingoStudent, BoardView: BingoBoard, TeacherView: BingoTeacher };
export const sort = { key: "sort", label: "Sınıflandırma / Eşleştirme", SettingsForm: ActivitySettings, StudentView: SortStudent, BoardView: SortBoard, TeacherView: SortTeacher };
export const written = { key: "written", label: "Yazılı Yanıt", SettingsForm: ActivitySettings, StudentView: WrittenStudent, BoardView: QuizBoard, TeacherView: QuizTeacher };
export const boardsort = { key: "boardsort", label: "Tahtada Sınıflandırma", SettingsForm: ActivitySettings, StudentView: BoardSortStudent, BoardView: BoardSortBoard, TeacherView: BoardSortTeacher };
